var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FontElementSettingModal } from '../base/font-element-setting-modal';
import { Component, ViewChild } from '@angular/core';
var WeatherModalComponent = /** @class */ (function (_super) {
    __extends(WeatherModalComponent, _super);
    function WeatherModalComponent(injector) {
        return _super.call(this, injector, 'weatherModal') || this;
    }
    WeatherModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        var componentData = editedComponent.model.data;
        this.backgroundColor = componentData.fill;
        this.fontColor = componentData.stroke;
        this.configureId = editedComponent.configureId;
        this.loadFontInfo(componentData);
        this.text = componentData.text;
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
    };
    WeatherModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('weather settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.staticTabs.tabs[1].active = true;
            this.currentDiagram.rollbackTransaction();
            return;
        }
        this.saveFontInfo();
        this.saveComponentProperty('stroke', this.fontColor);
        this.saveComponentProperty('fill', this.backgroundColor);
        this.currentDiagram.commitTransaction('weather settings');
        this.close();
    };
    WeatherModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    WeatherModalComponent.prototype.setBackgroundColor = function (color) {
        this.backgroundColor = color;
    };
    WeatherModalComponent.prototype.setFontColor = function (color) {
        this.fontColor = color;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], WeatherModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], WeatherModalComponent.prototype, "staticTabs", void 0);
    WeatherModalComponent = __decorate([
        Component({
            selector: 'weather-modal',
            template: "<div bsModal #settingModal=\"bs-modal\" allow-drag id=\"weatherSettingModal\" class=\"modal fade weatherSettingModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog design-modal-dialog\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <div class=\"fe-modal-header-title\"> {{lc(\"Weather\")}} </div> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <form class=\"configure\" *ngIf=\"active\" #textAttributeForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"fe-modal-middle valueShow design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"address-div\"> <label>{{lc('DeviceAddress')}}:</label> <span class=\"read-address-text\">{{lc('ReadDeviceAddress')}}</span> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BackGroundColor\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"backgroundColor\" (sentColor)=\"setBackgroundColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"FontColor\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"fontColor\" (sentColor)=\"setFontColor($event)\"></color-picker> </div> </div> </div> </div> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true' [isSizeEnable]=\"false\"></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!textAttributeForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div> ",
            styles: [".design-modal-dialog { .read-address-text { margin-left: 20px; } .address-div { margin-bottom: 12px; } .modal-content { width: 630px; } .modal-header { border-bottom: 1px solid #F4F4F4 !important; } }"]
        })
    ], WeatherModalComponent);
    return WeatherModalComponent;
}(FontElementSettingModal));
export { WeatherModalComponent };
